// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"kit_wrapper__jnao2","title":"kit_title__z108F"};